/* istanbul ignore file */
import React from "react";
import ReactDOM from "react-dom";
import "adviesbox-shared/adviesbox-shared.modern.css";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
